/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Label.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-label");
var Label = /** @class */ (function (_super) {
    tslib_1.__extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.prototype.renderLink = function () {
        var _a = this.props, link = _a.link, onLinkClick = _a.onLinkClick;
        if (!link) {
            return null;
        }
        if (typeof link === "string") {
            return (React.createElement("a", { href: "#", onClick: onLinkClick, className: moduleClassName("link") }, link));
        }
        return React.cloneElement(link, tslib_1.__assign({ className: classnames(moduleClassName("link"), link.props.className) }, link.props), link.props.children);
    };
    Label.prototype.render = function () {
        var _a = this.props, htmlFor = _a.htmlFor, label = _a.label;
        return (React.createElement("div", { className: "m-label" },
            label && React.createElement("label", { htmlFor: htmlFor }, label),
            this.renderLink()));
    };
    Label.propTypes = {
        htmlFor: PropTypes.string,
        label: PropTypes.node,
        link: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        onLinkClick: PropTypes.func
    };
    return Label;
}(React.Component));
exports.Label = Label;